import { useEffect } from "react";
import { useTranslation } from "react-i18next";

//tools
import cc from "classcat";

//redux
import { useSelector } from "react-redux";

//styles
import styles from "./TopControls.module.css";

//icons
import Basket from "../../assets/basket.svg";
import GreyCross from "../../assets/grey-cross.svg";
import AutoPlay from "../../assets/autoplay.svg?react";

const TopControls = ({
	basketAnim,
	menuGuid,
	tableGuid
}) => {
	const { t } = useTranslation();
	const productsCount = useSelector((state) => state.basket.products_count);
	const audioAutoPlay = useSelector((state) => state.chat.audio_auto_play);

	const onBasketClick = () => {
		if(!menuGuid || !tableGuid) return;
		const params = {
			mguid: menuGuid,
			tguid: tableGuid
		};

		const url = `${window?.__cng_common.build_url('/menu/', params)}#bottom-sheet-opened`;

		window?.__cng_common.load_page_ajax(url, false);
		window.store.emit("close_chat");
	};

	return (
		<div className={styles["top-controls-container"]}>
			<div className={styles["basket-container"]} onClick={onBasketClick}>
				<img
					src={Basket}
					alt={t("Basket")}
					className={cc([
						styles["basket-icon"],
						basketAnim && styles["basket-icon-bounce"]
					])}
				/>
				<span
					className={cc([
						styles["basket-count"],
						basketAnim && styles["basket-count-bounce"]
					])}
				>
					{productsCount}
				</span>
			</div>
			<button
				type="button"
				className={cc([
					styles["autoplay-button"],
					audioAutoPlay && styles["autoplay-button-on"],
				])}
				onClick={() => window.store.emit('toggle_audio_auto_play')}
			>
				<AutoPlay className={cc([styles['autoplay-icon'], audioAutoPlay ? styles['green'] : styles['gray']])} />
			</button>
			<img
				src={GreyCross}
				alt={t("Close")}
				className={styles["close-icon"]}
				onClick={() => window.store.emit('hide_chat')}
			/>
		</div>
	);
};

export default TopControls;